import styled from 'styled-components';

export const StyledTextSkeleton = styled.div`
    display: flex;
    flex-direction: column;
`;
